import { render, staticRenderFns } from "./AttainmentCalculationMethods.vue?vue&type=template&id=671a9f2e&scoped=true"
import script from "./AttainmentCalculationMethods.vue?vue&type=script&lang=js"
export * from "./AttainmentCalculationMethods.vue?vue&type=script&lang=js"
import style0 from "./AttainmentCalculationMethods.vue?vue&type=style&index=0&id=671a9f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a9f2e",
  null
  
)

export default component.exports